/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Machine_Id_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Offline Machine Id" |
*
* @param {Offline_Activation_Machine_Id_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_machine_id_placeholder = /** @type {((inputs?: Offline_Activation_Machine_Id_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Machine_Id_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Identifiant machine hors ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Offline-Maschinen-ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("ID macchina offline")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Идентификатор автономного устройства")
	if (locale === "es") return /** @type {LocalizedString} */ ("Id. de máquina sin conexión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("离线机器 ID")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オフラインマシンID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑफ़लाइन मशीन आईडी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("ID da máquina offline")
	return /** @type {LocalizedString} */ ("Offline Machine Id")
});